import React from 'react';
import WhoWeAre from '../../Component/WhoWeAre/WhoWeAre';
import KeyConsultants from '../../Component/KeyConsultants/KeyConsultants';

const About = () => {
    return (
        <div>
            <WhoWeAre/>
            <KeyConsultants/>
        </div>
    );
};

export default About;